import {
  isClassroomTeacherEnrolledManually,
  isTeacherEnrolledInClassroomManually,
} from '../enrollment';
import type { ClassroomTeacher } from '../teacher';
import type { Classroom } from './classroom';
import { isClassroomCreatedManually } from './classroom';

type DeleteClassroomCapabilities = {
  classroom: Classroom | null | undefined;
  isUpdatePeriod: boolean;
};

function canDeleteClassroom({
  classroom,
  isUpdatePeriod,
}: DeleteClassroomCapabilities): boolean {
  return (
    classroom?.numberOfStudents === 0 &&
    !isUpdatePeriod &&
    isClassroomCreatedManually(classroom)
  );
}

type TeacherLeaveClassroomParams = {
  classroom: Classroom | null | undefined;
  teacherId: string;
};

function canTeacherLeaveClassroom({
  classroom,
  teacherId,
}: TeacherLeaveClassroomParams): boolean {
  if (!classroom) {
    return false;
  }

  return isTeacherEnrolledInClassroomManually(classroom, teacherId);
}

type ClassroomTeacherLeaveClassroomParams = {
  teacher: ClassroomTeacher;
};

function canClassroomTeacherLeaveClassroom({
  teacher,
}: ClassroomTeacherLeaveClassroomParams): boolean {
  if (!teacher) {
    return false;
  }

  return isClassroomTeacherEnrolledManually(teacher);
}

export {
  canClassroomTeacherLeaveClassroom,
  canDeleteClassroom,
  canTeacherLeaveClassroom,
};
